/* Modulo: Hero Split — section behaviour.
   Vanilla IIFE, no deps. Handles:
     - Reduced-motion defense-in-depth: flips data-ken-burns /
       data-tag-pulse / data-cta-shimmer attrs to "0" so CSS gates
       disable the animations even before the media query kicks in.
     - Dedup via __moduloHspInit flag.
   All visual motion (ken-burns, pulse, shimmer, scroll-cue) is
   CSS-driven — this file only guards the motion toggles. */
(function () {
  'use strict';
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSection(section) {
    if (section.__moduloHspInit) return;
    section.__moduloHspInit = true;
    if (REDUCE) {
      section.setAttribute('data-ken-burns', '0');
      section.setAttribute('data-tag-pulse', '0');
      section.setAttribute('data-cta-shimmer', '0');
    }
  }

  function bootstrap() {
    if (window.moduloLazyInit) {
      window.moduloLazyInit('[data-modulo-hsp]', initSection);
    } else {
      var els = document.querySelectorAll('[data-modulo-hsp]');
      for (var i = 0; i < els.length; i++) initSection(els[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
